import {
  CREATE_WARRANTY_FEE,
  DELETE_WARRANTY_FEE,
  EDIT_WARRANTY_FEE,
  RECEIVE_WARRANTY_FEES,
  REQUEST_ALL_WARRANTY_FEES,
  REQUEST_WARRANTY_FEE,
} from '@sophocles/entities/WarrantyFee/warrantyFeeActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_WARRANTY_FEES: // Read
      return state.merge(action.warrantyFees);
    case DELETE_WARRANTY_FEE: // Delete
      return state.delete(action.warrantyFee.toString());
    case EDIT_WARRANTY_FEE: // Update
    case CREATE_WARRANTY_FEE: // Create
    case REQUEST_WARRANTY_FEE:
    case REQUEST_ALL_WARRANTY_FEES:
    default:
      return state;
  }
}

export function warrantyFeeReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_WARRANTY_FEE:
    case DELETE_WARRANTY_FEE:
    case RECEIVE_WARRANTY_FEES:
    case EDIT_WARRANTY_FEE:
    case REQUEST_WARRANTY_FEE:
    case REQUEST_ALL_WARRANTY_FEES:
      return getState(state, action);
    default:
      return state;
  }
}
